import React, { useEffect, useState } from 'react';
import { List, Card, Avatar } from 'antd';
import { EllipsisOutlined, UserOutlined } from '@ant-design/icons';
import { instanceAxios } from '../../InstanceAxios';

function Label({ status, countNotSendEmail }) {
  return (
    <div
      style={{
        backgroundColor: status === 'success' ? 'green' : 'red',
        borderRadius: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        width: '25%',
        padding: 5,
      }}
    >
      {status === 'success'
        ? 'Envio realizado com sucesso'
        : `${countNotSendEmail} email não enviados`}
    </div>
  );
}

function CardEmail({ item }) {
  const [collapse, setCollapse] = useState(false);
  const [arrayActions, setArrayActions] = useState([]);
  const [arrayWithEmails, setArrayWithEmails] = useState([]);

  useEffect(() => {
    if (item.status === 'error') {
      setArrayActions([
        <EllipsisOutlined
          key="ellipsis"
          onClick={() => setCollapse((value) => !value)}
        />,
      ]);
      console.log(item, item.emails_nao_enviados);
      const array = item.emails_nao_enviados.split('|');
      console.log(array);
      setArrayWithEmails(array);
    }
  }, []);

  return (
    <List.Item>
      <Card bordered={false} actions={arrayActions}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontFamily: 'Lato',
          }}
        >
          {item.assunto}
          <Label
            status={item.status}
            countNotSendEmail={item.total_emails_nao_enviados}
          />
        </div>
        {collapse ? (
          <List
            header={
              <div style={{ fontFamily: 'Lato' }}>
                Lista de e-mails quais não receberam:
              </div>
            }
            itemLayout="horizontal"
            dataSource={arrayWithEmails}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<Avatar icon={<UserOutlined />} />}
                  title={
                    <div style={{ fontFamily: 'Lato' }}>Endereço e-mail:</div>
                  }
                  description={<div style={{ fontFamily: 'Lato' }}>{item}</div>}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                />
              </List.Item>
            )}
          />
        ) : (
          <></>
        )}
      </Card>
    </List.Item>
  );
}

function HistoricoEnvioEmail() {
  const [data, setData] = useState([]);

  useEffect(() => {
    (async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get('/historicoEnvioEmails')
        .then((res) => {
          setData(res.data.data);
          console.log('ARRAY', res.data.data);
        })
        .catch((err) => {});
    })();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Card
        bordered={false}
        style={{
          marginBottom: '2%',
          width: '50%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: 'Lato',
            fontSize: '1.3rem',
          }}
        >
          Histórico de Envio de E-mail
        </div>
      </Card>
      <List
        grid={{ gutter: 16, column: 1 }}
        pagination={{
          onChange: (page) => {
            console.log(page);
          },
          pageSize: 10,
        }}
        dataSource={data}
        renderItem={(item) => <CardEmail item={item} />}
        style={{ width: '100%' }}
      />
    </div>
  );
}

export default HistoricoEnvioEmail;
